/**------------- Custom Button constants -------------**/

/*  Types  */
export const CUSTOM_BUTTON_TYPES = {
	GENERAL: "custom-button",
	CTA: "cta-button",
	CONTACT: "contact-button",
};
export const CUSTOM_BUTTON_TYPE = "primary";

/*  Icon  */
export const CUSTOM_BUTTON_ICON_ALT = "button-icon";
